import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, useState, useLayoutEffect } from 'react';
import classnames from 'classnames';

var EllipsisItem = function EllipsisItem(_ref) {
  var className = _ref.className,
      scale = _ref.scale,
      children = _ref.children,
      style = _ref.style;
  var spanRef = useRef(null);
  var initClientHightRef = useRef(null);

  var _useState = useState({}),
      size = _useState[0],
      setSize = _useState[1];

  useLayoutEffect(function () {
    var _a, _b;

    if (!scale || scale === 1) {
      return;
    }

    initClientHightRef.current = {
      height: (_a = spanRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight,
      width: (_b = spanRef.current) === null || _b === void 0 ? void 0 : _b.clientWidth
    };
    var size = initClientHightRef.current;
    setSize({
      width: Math.ceil(size.width * scale)
    });
  }, [scale]);
  return _jsx("span", Object.assign({
    className: classnames('by-ellipsis-item', className),
    style: Object.assign(Object.assign({}, style), size)
  }, {
    children: _jsx("div", Object.assign({
      style: {
        transform: "scale(" + scale + ")"
      },
      ref: spanRef
    }, {
      children: children
    }))
  }));
};

export default EllipsisItem;